<template>
  <div class="results">
    <h2>Nos propositions</h2>
    <div class="offers">
      <ul class="items">
        <template v-for="step in stepOffers">
          <template v-for="offers in step">
            <li class="item" v-for="offer in offers" :key="offer.id" @click="onClickOffer(offer)">
              <a :href="offer.link" target="_blank">
                <span class="logo"><Icon :icon="offer.logo" /></span>
                <span class="title">{{ offer.title }}</span>
                <p class="desc">{{ offer.description }}</p>
                <span class="icon arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </span>
              </a>
            </li>
          </template>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Icon from './Icon'

export default {
  name: 'Offers',
  components: { Icon },
  props: {
    data: []
  },
  computed: {
    ...mapState([
        'stepOffers'
    ])
  },
  created() {
    if(this.$gtm) {
      this.$gtm.trackEvent(({
        category: 'Steps',
        action: 'click',
        label: 'Results'
      }))
    }
  },
  methods: {
    onClickOffer(offer) {
      if(this.$gtm) {
        this.$gtm.trackEvent(({
          category: 'Offer',
          action: 'click',
          label: offer.title
        }))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use '~@wide/styles-utils' as *;
@import '@/assets/scss/variables';

.results {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;

  .offers {
    width: 100%;
    height: 100%;

    .items {
      display: grid;
      width: 100%;
      grid-template-columns: repeat(2, 1fr);
      grid-auto-rows: min-content;
      grid-column-gap: 1rem;
      grid-row-gap: 1rem;
      list-style: none;
      padding-bottom: 4rem;

      @include bp-up(md) {
        height: 100%;
        grid-auto-rows: min-content;
        grid-template-columns: repeat(auto-fit, calc(25% - 2rem));
        justify-content: center;
        padding-bottom: 0;
      }

      .item {
        position: relative;
        padding: 2rem 1rem;
        font-size: 1.6rem;
        text-align: center;
        background-color: $white;
        color: $blue;
        border: 1px solid $white;
        border-radius: 1rem;
        cursor: pointer;
        transition: color 0.3s ease-out, background-color 0.3s ease-out;

        a {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-direction: column;
          width: 100%;
          height: 100%;
          color: inherit;
        }

        .logo {
          height: 4rem;
        }

        .title {
          display: block;
          font-size: 1.8rem;
          font-weight: $weight-bold;
          margin-top: 0.5rem;

          @include bp-up(md) {
            font-size: 2.4rem;
          }
        }

        .desc {
          display: block;
          flex: 0 0 50%;
          margin-top: 1rem;
          margin-bottom: 0;
          font-size: 1.4rem;

          @include bp-up(md) {
            font-size: 1.6rem;
          }
        }

        .arrow {
          position: absolute;
          bottom: 0.5rem;
          right: 0.5rem;

          svg {
            fill: $blue;
          }
        }

        @include bp-up(md) {
          &:hover {
            background-color: transparent;
            color: $white;

            .arrow {
              svg {
                fill: $white;
              }
            }

            .logo {
              ::v-deep .icon {
                fill: $white;
              }
            }
          }
        }
      }
    }

  }
}

</style>
